import script from "./LoadingModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingModal.vue?vue&type=script&setup=true&lang=js"

import "./LoadingModal.vue?vue&type=style&index=0&id=6303188e&scoped=true&lang=css"

import exportComponent from "/builds/sense/sense-signer/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6303188e"]])

export default __exports__